import React, { useEffect, useState } from 'react';
import { Container, Col, Row } from "react-bootstrap";
import { Link } from "gatsby"
import parse from "html-react-parser";
import ShowMoreText from "react-show-more-text";
import $ from 'jquery';
import PropertyDetailsMap from "../PropertyDetails/PropertyDetailsMap";
import PropertyNego from "../PropertyDetails/PropertyNego";
import './assets/styles/_index.scss';
import NegoImg from "../../images/property-nego.png"
import useDeviceMedia from '../../hooks/useDeviceMedia';

const PropertyDescription = (props) => {

    const [scroll, setScroll] = useState(false)

    const { isMobile, isTablet } = useDeviceMedia();

    useEffect(() => {
        window.addEventListener("scroll", () => {
            setScroll(window.scrollY > 500)
        })
    },[])
    
    function gotohash(event) {
        var thishash = event;
        $('html, body').animate({
          scrollTop: $(thishash).offset().top - 70
        }, 1000);
    }

    // Read more & less
    const executeOnClick = (isExpanded) => {
        var offSet = isMobile ? 130 : isTablet ? 180 : 200
        if (isExpanded) {
            $(".description-content").addClass("shown");
        } else {
            $(".description-content").removeClass("shown");
            $('html, body').animate({
                scrollTop: $('.description-content').offset().top - offSet
            });
        }
    }
    // Read more & less

    return (
        <section className="property-description-wrapper">
            <Container>
                <Row>
                    <Col xl={8}>
                        <div className="property-desc-address-wrapper">
                            {
                                props.holidayHomes === "holiday-homes" ?
                                <>
                                    {
                                        props?.propertyData?.display_address &&
                                        <h1 className="property-desc-price holiday-homes">{props?.propertyData?.display_address}</h1>
                                    }
                                    {
                                        props?.propertyData?.price &&
                                        <div className="property-desc-address holiday-homes">From <span>{props?.propertyData?.currency} {props?.propertyData?.price.toLocaleString()}</span> per month</div>
                                    }
                                </>
                                :
                                <>
                                    {
                                        props?.propertyData?.price &&
                                        <div className="property-desc-price">{props?.propertyData?.price.toLocaleString()} {props?.propertyData?.currency}</div>
                                    }
                                    {
                                        props?.propertyData?.display_address &&
                                        <h1 className="property-desc-address">{props?.propertyData?.display_address}</h1>
                                    }
                                </>
                            }
                            <ul className="list-inline property-desc-details">
                                {
                                    props.holidayHomes === "holiday-homes" ?
                                    ""
                                    :
                                    <>
                                        {
                                            props?.propertyData?.area &&
                                            <li className="list-inline-item">
                                                <div className="d-flex align-items-center"><i className="icon icon-property-pin"></i> {props?.propertyData?.area}</div>
                                            </li>
                                        }
                                    </>
                                }
                                {
                                    props?.propertyData?.bedroom > 0 &&
                                    <li className="list-inline-item">
                                        <div className="d-flex align-items-center"><i className="icon icon-property-bedroom"></i> {props?.propertyData?.bedroom} {props?.propertyData?.bedroom > 1 ? "bedrooms" : "bedroom"}</div>
                                    </li>
                                }
                                {
                                    props?.propertyData?.bathroom > 0 &&
                                    <li className="list-inline-item">
                                        <div className="d-flex align-items-center"><i className="icon icon-property-bathroom"></i> {props?.propertyData?.bathroom} {props?.propertyData?.bathroom > 1 ? "bathrooms" : "bathroom"}</div>
                                    </li>
                                }
                                {
                                    props?.propertyData?.floorarea_min &&
                                    <li className="list-inline-item">
                                        <div className="d-flex align-items-center"><i className="icon icon-sqft"></i> {props?.propertyData?.floorarea_min.toLocaleString()} sqft {props?.propertyData?.floorarea_type}</div>
                                    </li>
                                }
                            </ul>
                        </div>

                        <div className="property-description-divider"></div>

                        <div className="property-nego-details d-xl-none">
                            {/* <div className="d-flex align-items-center">
                                <div className="property-nego-img-wrapper">
                                    <img src={NegoImg} alt="nego-img" />
                                </div>
                                <div className="property-nego-name-details">
                                    <div className="property-nego-name">{props?.propertyData?.crm_negotiator_id?.name}</div>
                                    <div className="property-nego-desig">Senior Property Broker</div>
                                </div>
                            </div> */}
                             <PropertyNego propertyData={props?.propertyData} holidaySidebar={props.holidayHomes} isMobile={false} />
                            <div className="property-description-divider"></div>
                            
                        </div>
                        
                        {
                            props?.propertyData?.long_description &&
                            <div className="property-description-details">
                                <h2 className="description-heading">Description</h2>
                                <ShowMoreText
                                    lines={isMobile ? 8 : isTablet ? 7 : 5}
                                    more="Read More"
                                    less="Read Less"
                                    className="description-content"
                                    anchorClass="show-more-less-clickable"
                                    onClick={executeOnClick}
                                    expanded={false}
                                >
                                    <p>{parse(props?.propertyData?.long_description)}</p>
                                </ShowMoreText>
                            </div>
                        }

                        <div className="property-description-divider"></div>

                        {
                            props.holidayHomes === "holiday-homes" ?
                            ""
                            :
                            <>
                                <div className="property-description-key-details">
                                    <h2 className="description-heading">Key Details</h2>
                                    <ul className="list-inline key-details-list">
                                        {
                                            props?.propertyData?.extra?.referenceNumber &&
                                            <li className="list-inline-item">
                                                <div className="Key-details-heading">Property ID:</div>
                                                <div className="Key-details">{props?.propertyData?.extra?.referenceNumber}</div>
                                            </li>
                                        }
                                        {
                                            props?.propertyData?.price &&
                                            <li className="list-inline-item">
                                                <div className="Key-details-heading">Price:</div>
                                                <div className="Key-details">{props?.propertyData?.price.toLocaleString()} {props?.propertyData?.currency}</div>
                                            </li>
                                        }
                                        {
                                            props?.propertyData?.floorarea_min &&
                                            <li className="list-inline-item">
                                                <div className="Key-details-heading">Property Size:</div>
                                                <div className="Key-details">{props?.propertyData?.floorarea_min.toLocaleString()} {props?.propertyData?.floorarea_type}</div>
                                            </li>
                                        }
                                        {props?.propertyData?.extra?.lotsize > 0 &&
                                            <li className="list-inline-item">
                                                <div className="Key-details-heading">Property Lot Size:</div>
                                                <div className="Key-details">{props?.propertyData?.extra?.lotsize} ft2</div>
                                            </li>
                                        }
                                        {
                                            props?.propertyData?.room_details > 0 &&
                                            <li className="list-inline-item">
                                                <div className="Key-details-heading">Rooms:</div>
                                                <div className="Key-details">{props?.propertyData?.room_details}</div>
                                            </li>
                                        }
                                        {
                                            props?.propertyData?.bedroom > 0 &&
                                            <li className="list-inline-item">
                                                <div className="Key-details-heading">Bedrooms:</div>
                                                <div className="Key-details">{props?.propertyData?.bedroom}</div>
                                            </li>
                                        }
                                        {
                                            props?.propertyData?.bathroom > 0 &&
                                            <li className="list-inline-item">
                                                <div className="Key-details-heading">Bathrooms:</div>
                                                <div className="Key-details">{props?.propertyData?.bathroom}</div>
                                            </li>
                                        }
                                        {
                                            props?.propertyData?.reception > 0 &&
                                            <li className="list-inline-item">
                                                <div className="Key-details-heading">Receptions:</div>
                                                <div className="Key-details">{props?.propertyData?.reception}</div>
                                            </li>
                                        }
                                        {/* <li className="list-inline-item">
                                            <div className="Key-details-heading">Energy class:</div>
                                            <div className="Key-details">A+</div>
                                        </li> */}
                                    </ul>
                                </div>

                            </>
                        }

                        {/* {
                            props?.propertyData?.accomadation_summary.length > 0 &&
                            <>
                                <div className="property-description-divider"></div>
                                <div className="property-description-amenities">
                                    <h2 className="description-heading">Amenities</h2>
                                    <div class="d-flex flex-wrap amenities-list">
                                        {
                                            props?.propertyData?.accomadation_summary.map((amenitiesList) => {
                                                return (
                                                    <div className="amenities">{amenitiesList}</div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </>
                        } */}


                        {/* {
                            props?.propertyData?.latitude && props?.propertyData?.longitude &&
                            <>
                                <div className="property-description-divider"></div>
                                <div className="property-description-map">
                                    <h2 className="description-heading">Location</h2>
                                    <PropertyDetailsMap
                                        lat={props?.propertyData?.latitude}
                                        lng={props?.propertyData?.longitude}
                                    />
                                </div>
                            </>
                        } */}
                    </Col>
                    <Col xl={1}></Col>
                    <Col xl={3} className="d-xl-block d-none">
                        <div className={`property-right-side-details sticky-top ${scroll ? "scrolled" : ""}`}>
                            <PropertyNego propertyData={props?.propertyData} holidaySidebar={props.holidayHomes} isMobile={false}  />
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default PropertyDescription